export default function App() {
  return (
    <div
      className="relative w-screen h-screen overflow-hidden select-none"
      style={{ background: '#4C097C' }}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <img
          src="./ponder-logo.svg"
          alt="Ponder"
          draggable={false}
          style={{ width: 'clamp(360px, 55vw, 720px)' }}
        />
      </div>
    </div>
  )
}
